import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';

interface LoadingMaskProps {
  show: boolean;
}
/** 讀取中的遮罩 */
const TbLoadingMask = (props: LoadingMaskProps) => {
  const { show } = props;
  const [scrollY, setScrollY] = useState(window.scrollY);
  const updateScroll = () => {
    setScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', updateScroll);
    return () => window.removeEventListener('scroll', updateScroll);
  }, []);

  return (
    <div
      style={{
        display: show ? 'flex' : 'none',
        height: show ? '100%' : `calc( 100vh + ${scrollY + 50}px )`,
        position: 'absolute',
        zIndex: '4000',
        width: '100%',
        left: '0',
        top: '0',
        backgroundColor: 'rgb(0 0 0 / 30%)',
      }}
    >
      <Spinner
        style={{
          width: '2.5rem',
          height: '2.5rem',
          position: 'absolute',
          left: '50%',
          top: '50%',
        }}
        animation="border"
        variant="primary"
      />
    </div>
  );
};

export default TbLoadingMask;
